import script from "./TorchBeamLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./TorchBeamLayer.vue?vue&type=script&setup=true&lang=js"

import "./TorchBeamLayer.vue?vue&type=style&index=0&id=8375a5f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8375a5f2"]])

export default __exports__